import request from '@/utils/request'
import {
    baseUrl
} from './baseUrl.js'

/**
 * 查询线路列表
 * @param data
 */
export function akRouteList(data) {
    return request({
        url: baseUrl + '/route/manage/list',
        method: 'post',
        data
    })
}

/**
 * 查询线路详情（管理后台，需登录）
 * @param data
 */
export function akRouteDetail(data) {
    const id = data.id
    return request({
        url: baseUrl + `/route/manage/detail/${id}`,
        method: 'get'
    })
}

/**
 * 查询线路详情（WAP公开，无需登录）
 * @param data
 */
export function akRoutePublicDetail(data) {
    const id = data.id
    return request({
        url: baseUrl + `/route/public/detail/${id}`,
        method: 'get'
    })
}



